


































































import {
  computed, defineComponent, onMounted, onUnmounted,
} from '@vue/composition-api';
import { PropType } from 'vue';

export default defineComponent({
  name: 'BaseAppModal',
  emits: [
    'on-cancel-click',
    'transition-ended',
  ],
  props: {
    show: {
      type: Boolean,
      required: false,
      default: true,
    },
    fluid: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeable: {
      type: Boolean,
      required: false,
      default: true,
    },
    width: {
      type: Number,
      required: false,
      default: 440,
    },
    /**
     * the icon for the modal header, array of strings according to the font-awesome-icon prop spec
     */
    icon: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: undefined,
    },
    /**
     * the path to the modal header icon
     */
    iconImg: {
      type: String,
      required: false,
      default: undefined,
    },
    position: {
      type: String,
      required: false,
      default: 'center',
      validator: (value: string) => ['center', 'left', 'top', 'right', 'bottom'].indexOf(value) !== -1,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    progress: {
      type: Number,
      required: false,
      default: 0,
      validator: (value: number) => value >= 0 && value <= 100,
    },
    scrollable: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Revised modal design for FS22
     *
     * See [Layout](https://app.zeplin.io/project/5e9d83b0b104c078551d5f61/screen/619fc1ad067fe19ee8bac5d2) for Reference
     */
    revisedLayout: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup: (props, { slots, emit }) => {
    const bodyStyleClass = 'base-app-modal-open';
    const modalInnnerStyleClass = computed(() => ({
      [props.position]: true,
      'base-modal-inner--scrollable': props.scrollable,
      'base-modal-inner--revised': props.revisedLayout,
    }));

    onMounted(() => {
      document.body.classList.add(bodyStyleClass);
    });

    onUnmounted(() => {
      document.body.classList.remove(bodyStyleClass);
    });

    return {
      emit,
      footerSlot: computed((): boolean => typeof slots.footer !== 'undefined'),
      modalInnnerStyleClass,
      style: computed(() => ({
        '--width': `${props.width}px`,
      })),
    };
  },
});
